<template>
  <form id="step4" class @submit="sendForm">
    <h3 class="main_question"><strong>4/4</strong>{{ $t('Ödeme') }}</h3>
    <div class="card-input">
      <div class="summary">
        <div class="row" v-for="(product, index) in productPrices" :key="index">
          <div class="col-6">
            <div class="form-group">{{ product.name }}</div>
          </div>
          <div class="col-6 text-right">
            <div class="form-group">
              <b
                >₺{{ Number(((product.final_price * 100) / (100 + Number(product.vat_rate))).toFixed(2)) }}+KDV{{
                  product.type === 'subscription'
                    ? product.period === 'annual'
                      ? '/' + $t('Yıl')
                      : '/' + $t('Ay')
                    : ''
                }}</b
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="prices.discount" class="promotion-summary">
        <div class="row">
          <div class="col-6">
            <div class="form-group color-orange">{{ $t('İndirim Tutarı') }}</div>
          </div>
          <div class="col-6 text-right color-orange">
            <div class="form-group">
              -
              <b>₺{{ prices.discount }}</b>
            </div>
          </div>
        </div>
      </div>
      <hr class="hr-custom" />
      <div class="row">
        <template v-if="appliedAmount > 0">
          <div class="col-6 mt-2 color-orange mb-2">
            <div>{{ $t('affiliate.Credit Discount') }}</div>
          </div>
          <div class="col-6 text-right mt-2 color-orange">
            <div>
              <span>{{ formatPrice(Number(appliedAmount), '₺') }}</span>
            </div>
          </div>
        </template>
        <div class="col-6">
          <div class="form-group">{{ $t('Toplam Tutar KDV Dahil') }}</div>
        </div>
        <div class="col-6 text-right">
          <div class="form-group">
            <b>{{ formatPrice(Number(total), '₺') }}</b>
          </div>
        </div>
      </div>
      <Promotion
        ref="promotion"
        :companyType="companyType"
        :form="form"
        :companyId="company.id"
        :companyNationId="company.company_nation_id"
        :discount.sync="prices.discount"
        @update-products="updatePrices"
      />
      <Affiliate id="upgrade" ref="affiliate" :products="productPrices" @set-appliable-amount="setAppliableAmount" />

      <div>
        <CardSelection :selectedCard.sync="selectedCard" />
      </div>
      <div>
        <div v-if="selectedCard.id === 'other'">
          <h3 class="main_question">{{ $t('Kart Bilgileri') }}</h3>
          <div class="form-group" lang="tr">
            <InputField
              v-model="form.holder_name"
              name="credit-card-holder-name"
              :placeholder="$t('Kart üzerindeki isim')"
              type="text"
              v-validate="'required'"
              :error="errors.first('credit-card-holder-name')"
              :validateFields="fields['credit-card-holder-name']"
            />
            <error-box field="holder_name" />
          </div>
          <div class="form-group">
            <InputField
              v-model="form.number"
              v-mask="'#### #### #### ####'"
              name="credit-card-number"
              :placeholder="$t('Kart Numaranız')"
              :maxlength="19"
              type="text"
              @blur="cardMessage"
              v-validate="'required|check_card'"
              :error="errors.first('credit-card-number')"
              :validateFields="fields['credit-card-number']"
            />
            <error-box field="number" />
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <InputField
                  v-model="form.expire"
                  v-mask="'##/##'"
                  name="credit-card-expire-date"
                  :placeholder="$t('Son Kullanım Tarihi (aa/yy)')"
                  type="text"
                  v-validate="'required|check_expiry_date'"
                  :error="errors.first('credit-card-expire-date')"
                  :validateFields="fields['credit-card-expire-date']"
                />
                <error-box field="expire_year" />
                <error-box field="expire_month" />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <InputField
                  v-model="form.cvc"
                  v-mask="'####'"
                  name="credit-card-cvv"
                  :placeholder="$t('CVV - Arka yüzdeki 3 hane')"
                  type="text"
                  v-validate="'required|min:3|max:4'"
                  :error="errors.first('credit-card-cvv')"
                  :validateFields="fields['credit-card-cvv']"
                />
                <error-box field="cvc" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="form-group terms">
          <label :class="{ 'is-invalid': errors.first('commit') }" class="container_check version_2">
            <span v-html="$t('Ödeme Kabul Text', { link: this.privacyLink })"></span>
            <input
              v-model="form.commit"
              name="commit"
              type="checkbox"
              value="false"
              v-validate="'required'"
              :error="errors.first('commit')"
              class="required up"
            />
            <span class="checkmark mt-2"></span>
          </label>
          <span v-show="errors.first('commit')" class="show-invalid invalid-feedback">{{
            errors.first('commit')
          }}</span>
        </div>
      </div>

      <div v-if="this.$i18n.locale === 'tr'">
        <label
          :class="{ 'is-invalid': errors.first('agreement-privacy') }"
          class="container_check version_2 mt-2"
          name="ortak"
          style="padding-top: 8px"
        >
          <i18n path="home.terms_of_use.small_text" tag="span">
            <template v-slot:privacy_text>
              <a data-target="#privacy-global-modal" data-toggle="modal" href="#">{{
                $t('home.terms_of_use.privacy_text')
              }}</a>
            </template>
          </i18n>
          <input
            v-model="commitPrivacy"
            type="checkbox"
            value="false"
            class="required up"
            id="agreement-privacy"
            name="agreement-privacy"
            v-validate="'required'"
          />
          <span class="checkmark"></span>
        </label>
        <span v-show="errors.first('agreement-privacy')" class="show-invalid invalid-feedback">{{
          errors.first('agreement-privacy')
        }}</span>
      </div>
    </div>
    <a v-show="false" id="creditCardMessage" data-target="#accepted-credit-card-modal" data-toggle="modal" href="#" />
    <IyzicoAgreementModal />
    <FreePromotionAppliedModal />
    <AcceptedCreditCardModal />
    <PrivacyGlobalModal v-if="this.$i18n.locale === 'tr'" :is-customer="true" />
  </form>
</template>
<script>
import IyzicoAgreementModal from '../modals/policies/IyzicoModal';
import FreePromotionAppliedModal from '../modals/FreePromotionAppliedModal';
import AcceptedCreditCardModal from '../modals/AcceptedCreditCardModal';
import ProductStore from '../../stores/product';
import CompanyStore from '../../stores/company';
import InputField from '@/components/InputField.vue';
import PrivacyGlobalModal from '@/components/modals/policies/PrivacyGlobalModal';
import Promotion from '../Promotion';
import CardSelection from '@/components/CardSelection';

export default {
  computed: {
    total: function () {
      let finalPrice = 0;

      if (this.productPrices.length > 0) {
        finalPrice = this.productPrices.reduce((total, price) => total + (price.net_price - price.discount), 0);
      }
      return finalPrice - this.appliedAmount;
    },
    expire_month: function () {
      return this.form.expire.split('/')[0];
    },
    expire_year: function () {
      return this.form.expire.split('/')[1];
    },
  },
  watch: {
    total: function (val) {
      this.$emit('total', { currency: '₺', price: val });

      if (val === 0) {
        document.getElementById('freeSubscription').click();
      }
    },
  },
  data() {
    return {
      appliedAmount: 0,
      acceptedCreditCardModalPassive: false,
      prices: {
        documentPick: null,
        number: null,
        discount: null,
      },
      commitPrivacy: false,
      form: {
        product_id: [],
        expire: null,
        promotion_code: [],
        commit: false,
      },
      products: [],
      companyType: {},
      company: {},
      package: [],
      productPrices: [],
      selectedCard: {
        id: 'other',
      },
    };
  },
  created() {
    this.startWaiting();
    CompanyStore.dispatch('getCompany').then((s) => {
      const company = s.data.data[0];
      this.company = company;
      this.companyType = company.companyType.data;
      this.package = company.package;

      this.startWaiting();
      ProductStore.dispatch('getProducts', {
        company_type_id: company.company_type_id,
        appliablePromotionCode: 1,
      }).then((s) => {
        this.productsHandler(s);
      });
    });
  },
  methods: {
    setAppliableAmount(data) {
      this.appliedAmount = data;
    },
    updatePrices(data) {
      this.$refs.affiliate.resetAmount();
      this.productPrices.forEach((product) => {
        const found = data.products.find((element) => product.code === element.code);
        if (found && found.net_price !== 0) {
          Object.assign(product, found);
        }
      });
    },
    cardMessage(e) {
      if (!this.acceptedCreditCardModalPassive) {
        window.document.getElementById('creditCardMessage').click();
        this.acceptedCreditCardModalPassive = true;
      }
    },
    optional(variable) {
      if (variable) {
        return variable;
      }

      return {};
    },
    async productsHandler(s) {
      this.products = s.data.data;

      this.package.forEach((pack) => {
        const product = this.optional(this.product(pack, this.products));
        this.form.product_id.push(this.optional(this.product(pack, this.products)).id);
        this.productPrices.push(product);
      }, this);

      const appliablePromotions = this.products.reduce(function (result, product) {
        if (product.appliable_promotion_code) {
          result.push(product.appliable_promotion_code);
        }
        return result;
      }, []);
      if (appliablePromotions.length) {
        await this.$refs.promotion.$refs.promotionModal.applyCode(appliablePromotions);
      }
      this.checkAndShowErrorMessage(Number(this.subtotal).toFixed(2), '₺');

      this.endWaiting();
    },
    product(code, products) {
      if (!products) {
        return null;
      }

      const product = products.find(function (product) {
        return product.code === code;
      });

      return product;
    },
    getTotal() {
      return this.total;
    },
    sendForm(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const form = JSON.parse(JSON.stringify(this.form));
          if (this.selectedCard.id !== 'other') {
            delete form.expire_month;
            delete form.expire_year;
            delete form.number;
            delete form.expire;
            form.card_id = this.selectedCard.id;
          } else {
            form.expire_month = this.expire_month;
            form.expire_year = this.expire_year;
            form.number = this.form.number.replace(/ /g, '');
          }

          if (!form.promotion_code.length) {
            delete form.promotion_code;
          }
          if (this.appliedAmount) {
            form.wallet_amount = this.appliedAmount;
          }

          if (this.isWebView) {
            form.is_mobile = true;
          }

          this.startWaiting();
          $axios.put('register/' + this.company.id + '/pay', form).then((s) => {
            document.write(s.data.data.html_3d);
            document.close();

            this.endWaiting();
          });
        }
      });
    },
    informHubspot() {
      CompanyStore.dispatch('informHubspot', {
        name: this.company.users.data[0].name,
        surname: this.company.users.data[0].surname,
        email: this.company.users.data[0].email,
      });
    },
    completed() {
      this.informHubspot();
      this.$toasted.show(this.$t('AlertMessages.Ödemeniz başarıyla tamamlandı'), {
        duration: 60000,
      });
      // Callback to parent component
      // eslint-disable-next-line node/no-callback-literal
      callback(true);
    },
  },
  components: {
    IyzicoAgreementModal,
    FreePromotionAppliedModal,
    AcceptedCreditCardModal,
    PrivacyGlobalModal,
    InputField,
    Promotion,
    CardSelection,
  },
};
</script>
<style lang="less">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

label.version_2 {
  font-size: 12px;
}
</style>
